import React, {useState} from "react";
import PaddedSection from "../PaddedSection";
import CommentaryEntry from "../../commentary/CommentaryEntry";
import CloseIdeaButton from "./CloseIdeaButton";
import styled from "styled-components";
import ClosePortfolioList from "./ClosePortfolioList";
import {logAction} from "../../../../logging/logEvent";
import {CloseFailure} from "./CloseFailure";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

const PortfoliosAndCommentaryContainer = styled(PaddedSection)`
    display: flex;
    flex-grow: 1;
    padding-bottom: 10px;
`;

const IdeaDetailsCloseTab = ({idea, ideaActions, ideaDetails, closing, userIdentity, checkIdeaClosed}) => {
    const [commentary, setCommentary] = useState("");

    const numberOfPortfolios = closing.selectedBucketIds.length;
    const disabled = closing.inProgress || numberOfPortfolios === 0;

    const onCloseButtonClick = () => {
        if (disabled) {
            return;
        }

        logAction({
            type: "IDEA_DETAILS_CLOSE_BUTTON_CLICKED",
            bucketIds: closing.selectedBucketIds,
            comment: commentary
        });

        const selectedBucketIds = closing.selectedBucketIds ? closing.selectedBucketIds.slice() : [];
        const portfolios = ideaDetails.data.portfolios.filter(p => selectedBucketIds.includes(p.bucketId));

        ideaActions.closeIdea(checkIdeaClosed, portfolios, commentary, "TIM2_IDEA_DETAILS");
    };

    return (
        <Container className="t-close-content">
            <PortfoliosAndCommentaryContainer>
                <ClosePortfolioList portfolios={idea.portfolios} ideaActions={ideaActions} closing={closing}/>
                <CommentaryEntry title="Closing Commentary"
                                 disabled={closing.inProgress}
                                 commentary={commentary}
                                 onCommentaryUpdated={setCommentary}
                                 textLimit={userIdentity.commentLengthLimit}/>
            </PortfoliosAndCommentaryContainer>
            <CloseFailure error={closing.error}/>
            <CloseIdeaButton onClick={onCloseButtonClick}
                             disabled={disabled}
                             isLoading={closing.inProgress}
                             numberOfPortfolios={numberOfPortfolios}
                             closing={closing}/>
        </Container>
    );
};

export default IdeaDetailsCloseTab;